// src/DownloadExcelButton.js
import React from 'react';
import { collection, getDocs } from 'firebase/firestore';
import {db} from '../../firebase-config' ; 

import * as XLSX from 'xlsx';

const DownloadExcelButton = () => {
  const fetchDataAndDownload = async () => {
    // Fetch data from Firestore
    const querySnapshot = await getDocs(collection(db, "PPGIS_SURVEY"));
    const data = querySnapshot.docs.map(doc => doc.data());

    // Convert to Excel
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Download Excel file
    XLSX.writeFile(workbook, 'DataExport.xlsx');
  };

  return (
    <button style={{color:'rgb(255,255,255)',
    appearance:'none',
    border:'none',
    fontFamily:'inherit',
    fontWeight:'bold',
    outline:'none',
    backgroundColor:'rgb(0, 191, 255)',
    borderRadius:'1.214em',
    cursor:'pointer',
    fontSize:'0.6em',
    padding:'0.5em 2.786em 0.6em',
    textAlign:'center'}}
     onClick={fetchDataAndDownload}>Download Data as Excel</button>
  );
};

export default DownloadExcelButton;



